/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {handleThreeDomainSecureV2Action} from '../api'

export const useMutationHandleThreeDomainSecureV2Action = createReactQueryMutationHook('handleThreeDomainSecureV2Action', handleThreeDomainSecureV2Action)
